import { BetChipContext } from '@/contexts/BetChipContext';
import { GlobalDataContext } from '@/contexts/GlobalDataContext';
import { GlobalUserDataContext } from '@/contexts/GlobalUserDataContext';
import { MultiBetLiveContext } from '@/contexts/MultiBetLiveContext';
import { ScreenContext } from '@/contexts/ScreenContext';
import { ROUTE_LOBBY } from '@/models/Route';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { getHostById } from '@/modules/host/slice';
import { popupSliceActions } from '@/modules/popup/slice';
import { routeSliceActions } from '@/modules/routeController/slice';
import { RootState } from '@/store/store';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GameType as GameTypeEnum } from '../models/games/enums/GameType';
import { useBetSource } from './useBetSource';
import { useRwdUI } from './useRwdUI';
import { TableInfo } from './useTableBet';

const KICK_PLAYER_IDLE_COUNT: number = 10;
export const useTableInfo = (hostId: number) => {
    const [sideBetCurrentPage, setSideBetCurrentPage] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [betTypesByPage, setBetTypesByPage] =
        useState<Array<Array<number>>>();
    const lastTable = useRef<TableInfo>();
    const dispatch = useDispatch();
    const { isMultiBet } = useContext(GlobalDataContext);
    const { isAutoConfirm, setNotSupportAutoConfirm } = useContext(
        GlobalUserDataContext
    );
    const betSource = useBetSource(isMultiBet);

    const { pxToRwdCSSString } = useRwdUI();
    const [chipSize, setChipSize] = useState<string | undefined>(undefined);
    const { selectedBetAmount, selectedBetRule } = useContext(BetChipContext);

    const { setPendingBetState } = useContext(MultiBetLiveContext);
    const { isLandscape } = useContext(ScreenContext);
    const { GameType, MaxBet, GameID } = useSelector((state: RootState) =>
        getHostById(state, hostId)
    );
    const [noBetCount, setNoBetCount] = useState(0);

    const leaveTable = useCallback(() => {
        //cancel pending with last table
        if (lastTable.current && isAutoConfirm === false && !isMultiBet) {
            dispatch(
                tableBetSliceActions.clearPendingBets({
                    hostId: lastTable.current.hostId,
                    gameId: lastTable.current.gameId,
                    startGame: false,
                })
            );
            if (setPendingBetState)
                setPendingBetState(lastTable.current.hostId, false);
        }
    }, [isAutoConfirm, isMultiBet]);

    useEffect(() => {
        if (lastTable.current && hostId !== lastTable.current.hostId) {
            leaveTable();
            setNoBetCount(0);
        }
        lastTable.current = { hostId: hostId, gameId: GameID };
    }, [hostId, GameID]);

    useEffect(() => {
        if (noBetCount >= KICK_PLAYER_IDLE_COUNT + 1) {
            dispatch(routeSliceActions.goto(ROUTE_LOBBY));
            dispatch(popupSliceActions.open('system.idle_kick'));
        }
    }, [noBetCount]);

    useEffect(() => {
        return () => {
            leaveTable();
        };
    }, [hostId]);
    useEffect(() => {
        if (!isMultiBet)
            setNotSupportAutoConfirm(GameType == GameTypeEnum.Blackjack);
    }, [GameType]);
    useEffect(() => {
        if (isMultiBet) {
            setChipSize(undefined);
            return;
        }
        let val: number;
        switch (GameType) {
            case GameTypeEnum.Roulette:
            case GameTypeEnum.UltraRoulette:
            case GameTypeEnum.SicBo:
                val = isLandscape ? 46 : 50;
                break;
            case GameTypeEnum.FishPrawnCrab:
                val = isLandscape ? 60 : 50;
                break;
            default:
                val = isLandscape ? 60 : 65;
        }
        setChipSize(pxToRwdCSSString(val));
    }, [isLandscape, isMultiBet, GameType]);
    return {
        hostId,
        GameType,
        GameID,
        // _doPendingBet,
        // _doRouletteBet, //For Roulette string input bets
        // _doPendingBets, //For multi bet type, any bet type not available will cancel all bets
        // _doCancelBet,
        // _doConfirmBet,
        // _doUndoBet,
        // lastBetPage,
        // setLastBetPage,
        setCurrentPage,
        setBetTypesByPage,
        // GLIDisableBetTypesList,
        // disableBetTypes,
        // setExtraDisableBetTypes,
        // GameId,
        // MaxBet,
        // PrevBets,
        // displayBets,
        // ConfirmedBets,
        // PendingBets,
        // BetsSummary,
        // TableTotalBet,
        // PendingTotalBet,
        // isWaitingBet,
        // unavailableBetTypes,
        sideBetCurrentPage,
        setSideBetCurrentPage,
        chipSize,
        // setRebet,
        // setDoubleBet,
        // winTypes,
        // winAnimationController,
        // isBetting,
        // isShuffling,
        // CurrentResult,
        // IsRest,
        setNoBetCount,
        selectedBetAmount,
        selectedBetRule,
        isMultiBet,
        currentPage,
        betTypesByPage,
        betSource,
        MaxBet,
    };
};
export type useTableInfoState = ReturnType<typeof useTableInfo>;
